import { useCombobox } from '@mantine/core';
import { useFocusWithin } from '@mantine/hooks';
import { useState } from 'react';

import type { Option } from './multiselect';

export const useMultiselect = (data: Option[]) => {
  const { ref: inputRef, focused: inputFocused } = useFocusWithin();
  const { ref: dropdownRef, focused: dropdownFocused } = useFocusWithin();
  const combobox = useCombobox();

  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<string[]>([]);

  const handleValueSelect = (val: string) =>
    setSelected((current) =>
      current.includes(val)
        ? current.filter((v) => v !== val)
        : [...current, val]
    );

  const handleValueRemove = (val: string) =>
    setSelected((current) => current.filter((v) => v !== val));

  const handleSelectAll = () =>
    setSelected(allChecked ? [] : data.map(({ value }) => value));

  const allChecked = selected.length === data.length;
  const focused = inputFocused || dropdownFocused;

  return {
    allChecked,
    combobox,
    dropdownRef,
    focused,
    handleSelectAll,
    handleValueRemove,
    handleValueSelect,
    inputRef,
    search,
    selected,
    setSearch,
    setSelected,
  };
};
